import script from "./Shareholders.vue?vue&type=script&setup=true&lang=js"
export * from "./Shareholders.vue?vue&type=script&setup=true&lang=js"

import "./Shareholders.vue?vue&type=style&index=0&id=28e47d6a&lang=scss"

const __exports__ = script;

export default __exports__